import { Type as y } from "apache-arrow";
import g from "moment/moment";
async function Y(a, i, u, c = 1e3) {
  let l = !1;
  const f = a.toArray(), m = [];
  for (let o = 0; o < f.length; o += c) {
    const b = f.slice(o, o + c);
    await new Promise((r) => setTimeout(r, 0));
    try {
      const r = b.map((h) => {
        const w = h.toArray(), p = Object.fromEntries(
          a.schema.fields.map(({ name: n, type: s }, N) => {
            const e = i && i[n] || n, t = w[N];
            if (t == null) return [e, null];
            if (s.typeId === y.Decimal) {
              const d = Number(t.toString());
              return [
                e,
                isNaN(d) ? 0 : d / Math.pow(10, s.scale)
              ];
            }
            return typeof t == "bigint" ? [e, Number(t.toString())] : s.typeId === y.Date ? [
              e,
              g.utc(t).format("YYYY-MM-DD")
            ] : [e, t];
          })
        );
        return u && !l ? (l = !0, u.parse(p)) : p;
      });
      m.push(...r);
    } catch (r) {
      return console.error(r), [];
    }
  }
  return m;
}
export {
  Y as arrowToArray
};
